module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row center-block"
  }, [_c('div', [_c('b-alert', {
    attrs: {
      "variant": "success",
      "dismissible": "",
      "show": _vm.showDismissibleAlert
    },
    on: {
      "dismissed": function($event) {
        _vm.showDismissibleAlert = false
      }
    }
  }, [_vm._v("\n   " + _vm._s(_vm.messageAlert) + "\n ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    key: _vm.componentKey,
    staticClass: "box-body"
  }, [_c('text-reader', {
    on: {
      "load": function($event) {
        return _vm.enviarTexto($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('paginate', {
    staticClass: "paginate-list",
    attrs: {
      "name": "dados",
      "list": _vm.programacao,
      "per": 5
    }
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v("Empresa")]), _vm._v(" "), _c('th', [_vm._v("Ordem")]), _vm._v(" "), _c('th', [_vm._v("Ítem")]), _vm._v(" "), _c('th', [_vm._v("Sequência")]), _vm._v(" "), _c('th', [_vm._v("Máquina")]), _vm._v(" "), _c('th', [_vm._v("Tempo Previsto")]), _vm._v(" "), _c('th', [_vm._v("Quantidade")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.paginated('dados')), function(detalhe, index) {
    return _c('tr', {
      key: detalhe.id,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(detalhe.empresa))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(detalhe.ordem))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(detalhe.item))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(detalhe.sequencia))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(detalhe.maquina))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(detalhe.tempo_previsto))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(detalhe.quantidade))])])
  }), 0)])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('paginate-links', {
    attrs: {
      "for": "dados",
      "limit": 5,
      "show-step-links": true,
      "id": "paginacao"
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [(_vm.text !== '') ? [_c('div', {
    staticClass: "col-sm-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.limparFiles
    }
  }, [_vm._v("\n              Cancelar\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.enviarTextoServidor
    }
  }, [_vm._v("\n              Importar\n            ")])])] : _vm._e()], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header col-md-12"
  }, [_c('h3', [_vm._v("Importar programação em csv")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5df66408"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/ImportarProgramacao.vue
// module id = 638
// module chunks = 1